<template>
  <div>
    <switcher-aziende />
    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <b-card >
      <template #header>
        <h4 class="mb-0">Piani Welfare</h4>
      </template>
      <b-row class="mb-2">
        <b-col cols="12" md="2">
          <div class="d-flex">
            <b-form-select class="mr-2" style="width: 30vh" v-model="selectedYear" :options="options"></b-form-select>
            <b-form-select style="width: 30vh" v-model="selectedPlane" :options="expiredOptions"></b-form-select>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col >
          <!-- Tabella dei piani -->
          <!-- no-provider-sorting e no-provider-filtering evita che per ogni azione
              di sorting o filtraggio venga chiamato il backend, ma venga fatto dalla
              tabella stessa. Non usiamo la proprietà stacked su schermi piccoli prediligendo
              il formato tabellare. -->
          <b-table responsive
                   id="mainTable"
                   stacked="sm"
                   :per-page="page_size"
                   :current-page="page"
                   :filter="String(selectedYear)"
                   :filter-function="myFilter"
                   :no-provider-filtering="true"
                   :no-provider-sorting="true"
                   :items="allData"
                   :fields="fields"
                   primary-key="wpw_id"
                   show-empty>

            <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
                 chiamata la funzione che prende i dati --->
            <template v-slot:table-busy>
              <div class="d-flex my-2 justify-content-center align-items-center">
                <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
                <strong>Caricamento</strong>
              </div>
            </template>

            <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
                  la proprietà "show-empty" alla tabella -->
            <template v-slot:empty>
              <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/> Nessun elemento disponibile</p>
            </template>

            <!-- Slot che visualizza un messaggio quando il filtro non restituisce risultati, deve essere aggiunta
                  la proprietà "show-empty" alla tabella -->
            <template v-slot:emptyfiltered>
              <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento trovato</p>
            </template>

            <template #cell(index)="data">
              <span >{{data.index}}</span>
            </template>

            <!-- Aggiungo il contenuto nella colonna link, non avendo il file nell'API lo si aggiunge un button variante link così da poi poter chiamare la funzione per scaricare il file -->
            <template #cell(link)="data">
              <span class="text-info link_property" style="cursor: pointer" @click="downloadReport(data.item.wpw_id)" >Scarica file</span>
            </template>

            <template #cell(wpw_id)="row">
              <TableAnnidata :row="row" />
            </template>

            <template #row-details="row">
                <PadreTabellaAnnidata :childRow="row.item" :fields="fields" :getParentRow="getParentRow" :downloadReport="downloadReport" />
            </template>

          </b-table>

          <b-pagination v-model="page" :total-rows="items_tot" :per-page="page_size" align="center"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import PageTagline from "@/components/PageTagline.vue";
import SwitcherAziende from "@/components/refaziendale/SwitcherAziende.vue";
import axios from "axios";
import {apiUrl} from "@/apiUrl";
import {generalLib} from "@/generalLib";
import moment from "moment";
import TableAnnidata from "@/views/RefAziendale/TabellaAnnidata/TableAnnidata.vue";
import PadreTabellaAnnidata from "@/views/RefAziendale/TabellaAnnidata/PadreTabellaAnnidata.vue";



export default {
  name: "PianiWelfare",
  data(){
    return {
      overlay_show: false,
      tagline_elem: [{ text: 'Piani Welfare', link: 'office-ref-azi-piani-welfare'}],
      page_size: 50,
      count: 0,
      countPageSize: 0,
      page: 1,
      items_tot: 0,
      allData: [],
      filter: null,
      fields: [
        {
          key: 'wpw_id',
          label:'Identificativo',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'wpw_descrizione',
          label:'Descrizione',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'wpw_data_decorrenza',
          label:'Data decorrenza',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'wpw_data_scadenza',
          label:'Data scadenza',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'link',
          label:'Link',
          class: 'text-center',
        },
      ],
      selectedYear : 0,
      selectedPlane:1,
      expiredOptions: [
        {
          value: 1, text: 'Tutti i piani'
        },
        {
          value: 2, text: 'Piani scaduti'
        },
        {
          value: 3, text: 'Piani attivi'
        },
      ],
      options: []
    }
  },
  methods:{

    getParentRow(child) {
      const father = this.allData.find(item => item.wpw_id === child.wpw_id_piano_padre);
      if(father){
        const dateExpired = moment(father.wpw_data_scadenza, "DD-MM-YYYY")
        this.is_expired_date(dateExpired) ? father['_rowVariant'] = 'danger' : null;
        this.about_to_expired(dateExpired) ? father['_rowVariant'] = 'warning' : null;
        return {...father , wpw_id: father.wpw_id };
      }
      return null
    },
    is_expired_date: function(date){
      return date.diff(moment(), 'days') < 0;
    },
    about_to_expired: function(date){
      const DAY_LIMIT = 10;
      const diff = date.diff(moment(), 'days');
      return diff >= 0 && diff <= DAY_LIMIT;
    },
    add_class_date : function (elem, date, keyAPI ){
      let data_dec = moment(date)
      let data_dec_format = data_dec.format('DD-MM-YYYY')

      if(this.is_expired_date( data_dec ) ) {
        elem['_rowVariant'] = 'danger';
        elem[keyAPI] = data_dec_format

      }else if(this.about_to_expired(data_dec) ) {
        elem['_rowVariant'] = 'warning';
        elem[keyAPI] = data_dec_format;
      }else{
        elem[keyAPI] = data_dec_format
      }
    },
    makeToast(append = false, download = false) {
      this.$bvToast.toast(download ? 'download in corso' : 'download riuscito', {
        title: download ? 'Caricamento' : 'File scaricato',
        autoHideDelay: download ? 0 : 5000,
        appendToast: append,
        variant: download ? 'info' : 'success',
        toaster: 'b-toaster-bottom-center'
      })
    },
    downloadReport(id) {
      const filename = `piano_${id}_crediti.xlsx`; // nome file fisso
      this.makeToast(undefined, true)
      axios.get( apiUrl.welfareapi.piani_welfare_download.replace('@id', id), {
        responseType: "blob",
      })

          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();

            this.makeToast()
          })
          .catch(err => {
            console.error(err);
            this.$bvToast.toast("Impossibile scaricare il file.", {
              title: "Errore",
              variant: "danger",
              solid: true
            });
          });
    },
    myFilter(row, filter) {
      if (!filter) return true;

      const dateToFilter = moment(row.wpw_data_scadenza, "DD-MM-YYYY").year();
      const dateExpired = moment(row.wpw_data_scadenza, "DD-MM-YYYY")

      const year = dateToFilter === this.selectedYear
      const allYear = this.selectedYear === 0

      const ifExpiredDateOrNot = (this.selectedPlane === 2 && this.is_expired_date(dateExpired)) || (this.selectedPlane === 3 && !this.is_expired_date(dateExpired))
      const allPiani = this.selectedPlane === 1

      const res = (year || allYear) && (ifExpiredDateOrNot || allPiani)
      this.count ++
      if(res === true){
        this.countPageSize += 1
      }

      if(this.count === this.allData.length){
          this.items_tot = this.countPageSize
          this.countPageSize = 0
          this.count = 0
      }
      return res
    }
  },
  created() {
    const startYear = 2020
    const count = moment().year()+10 - startYear;
    this.options.push({value: 0, text: 'Tutti gli anni'})
    for (let i = 0; i <= count; i++) {
      const year = moment(`${startYear}`, 'YYYY').add(i, 'years').year()
      this.options.push({value: year, text: year})
    }

    this.overlay_show = true;

    axios.get( apiUrl.welfareapi.get_piani_welfare )
        .then(response => {

          this.items_tot = response.data.count;
          this.allData = response.data.results;

          for ( let elem of response.data.results ) {

            this.add_class_date(elem,elem.wpw_data_scadenza,'wpw_data_scadenza')

          }

          this.overlay_show = false

        })
        .catch(error => {
          let mess = "Si è verificato un errore nel caricamento dei dati:"
          generalLib.backend_error_message_box( this, error.response.data, mess );
        })

  },
  components:{
    SwitcherAziende,
    PageTagline,
    TableAnnidata,
    PadreTabellaAnnidata
  }
}
</script>

<style scoped>
.link_property:hover {
  text-decoration: underline;
}
</style>